import { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import dayjs from 'dayjs';

import { LocationAddress } from '@components';
import { GlobalContext } from '@contexts';
import {
  Edit2Icon,
  ExternalLinkIcon,
  MonitorIcon,
  MoreHorizontalIcon,
} from '@svgs';

import './AuthorRow.scss';

const AuthorRow = ({ author }) => {
  const { t, i18n } = useTranslation();
  const globals = useContext(GlobalContext);

  return (
    <div className="sb-row-item">
      <div className="sb-row--author-name">
        <p>
          <Link
            to={`/dashboard/sites/${author.site_id}/blogs/authors/${author.id}`}
          >
            {author.name}
          </Link>
        </p>
      </div>
      <div className="sb-row--author-title">
        <p>{author.title}</p>
      </div>
    </div>
  );
};

export default AuthorRow;
